import { useState } from 'react';
import { FormControlLabel, IconButton, InputAdornment, MenuItem, Radio, RadioGroup, TextField, Tooltip } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { applicationCounts, sameId } from './discoveryModel';

export default function CommonHazardPicker({ library, assets, causes, value, onChange, disabled }) {
  const [search, setSearch] = useState('');
  const [source, setSource] = useState('all');
  const [category, setCategory] = useState('');
  const [cause, setCause] = useState('');
  const categories = [...new Set(library.map(row => row.danger_category).filter(Boolean))];
  const causeNames = [...new Set(library.filter(row => !category || row.danger_category === category).map(row => row.danger_cause).filter(Boolean))];
  const terms = search.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
  const options = library.filter(row => {
    const text = [row.danger_description, row.danger_category, row.danger_cause].join(' ').toLocaleLowerCase();
    return (source === 'all' || (source === 'worker') === (Number(row.worker_proposal_source) === 1))
      && (!category || row.danger_category === category) && (!cause || row.danger_cause === cause)
      && terms.every(term => text.includes(term));
  });
  const filtered = Boolean(search || category || cause || source !== 'all');
  const assetIds = assets.map(row => row.register_asset_id);

  return <div className="hazard-library">
    <TextField size="small" fullWidth autoFocus label="공통 위험요인 검색" placeholder="내용, 위험분류, 세부 위험유형 검색"
      value={search} disabled={disabled} onChange={event => setSearch(event.target.value)}
      onKeyDown={event => { if (event.key === 'Enter') event.preventDefault(); }}
      InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment> }} />
    <div className="hazard-library-filters">
      <TextField select size="small" label="출처" value={source} disabled={disabled} onChange={event => setSource(event.target.value)}>
        <MenuItem value="all">전체</MenuItem><MenuItem value="manual">일반 등록</MenuItem><MenuItem value="worker">근로자 제안</MenuItem>
      </TextField>
      <TextField select size="small" label="위험분류" value={category} disabled={disabled} InputLabelProps={{ shrink: true }} SelectProps={{ displayEmpty: true }} onChange={event => { setCategory(event.target.value); setCause(''); }}>
        <MenuItem value="">전체</MenuItem>{categories.map(name => <MenuItem key={name} value={name}>{name}</MenuItem>)}
      </TextField>
      <TextField select size="small" label="세부 위험유형" value={cause} disabled={disabled} InputLabelProps={{ shrink: true }} SelectProps={{ displayEmpty: true }} onChange={event => setCause(event.target.value)}>
        <MenuItem value="">전체</MenuItem>{causeNames.map(name => <MenuItem key={name} value={name} sx={{ whiteSpace: 'normal' }}>{name}</MenuItem>)}
      </TextField>
      <Tooltip title="검색·필터 초기화"><span><IconButton aria-label="검색·필터 초기화" disabled={disabled || !filtered}
        onClick={() => { setSearch(''); setSource('all'); setCategory(''); setCause(''); }}><RestartAltIcon /></IconButton></span></Tooltip>
    </div>
    <div className="hazard-library-count" role="status">검색 결과 {options.length}건 <span>전체 {library.length}건</span></div>
    <RadioGroup className="hazard-library-list" aria-label="공통 유해·위험요인 목록" value={String(value || '')}
      onChange={event => !disabled && onChange(event.target.value)}>
      {options.map(row => {
        const counts = applicationCounts(assetIds, row.danger_cause_id, causes);
        const duplicate = assetIds.length > 0 && counts.added === 0;
        return <FormControlLabel key={row.danger_cause_id} value={String(row.danger_cause_id)} disabled={disabled}
          className={`hazard-library-option${sameId(row.danger_cause_id, value) ? ' is-selected' : ''}`}
          control={<Radio size="small" inputProps={{ 'aria-label': row.danger_description }} />}
          label={<span className="hazard-library-option-content">
            <span className="hazard-library-description">{row.danger_description}</span>
            <span className="hazard-library-meta"><span>{row.danger_category} · {row.danger_cause}</span>
              <span>{Number(row.worker_proposal_source) === 1 ? '근로자 제안' : '일반 등록'}</span>
              {duplicate && <span className="hazard-library-duplicate">이미 등록됨</span>}
            </span>
          </span>} />;
      })}
      {!options.length && <div className="hazard-library-empty">{library.length ? '검색 조건에 맞는 위험요인이 없습니다.' : '등록된 공통 유해·위험요인이 없습니다.'}</div>}
    </RadioGroup>
  </div>;
}
